import { useEffect, useState } from 'react'

import { useBootSplashGone } from '@/lib/bootSplash'

const REVEAL_DELAY_MS = 600

/** False on mount, then true shortly after the boot splash has gone: for content that animates in once the page settles. */
export function useRevealAfterLoad(enabled: boolean): boolean {
  const [revealed, setRevealed] = useState(false)
  const splashGone = useBootSplashGone()

  useEffect(() => {
    if (!enabled || !splashGone) return
    const timer = window.setTimeout(() => setRevealed(true), REVEAL_DELAY_MS)
    return () => window.clearTimeout(timer)
  }, [enabled, splashGone])

  return !enabled || revealed
}
